import { Box, Flex, Text } from '@shared/components';
import { useMemo } from 'react';

import { FailedResult } from '../../components';
import { useQSetSimilarityResult } from '../../providers';

export default function QSetSimilarityFailedResult() {
  const { courseId, similarityResult } = useQSetSimilarityResult();
  const failedResults = useMemo(
    () =>
      [...similarityResult.data]
        .filter((result) => result.duplicationRate > similarityResult.duplicationRate)
        .sort((a, b) => {
          const numA = parseInt(a.qSetACode.replace(/\D/g, ''), 10);
          const numB = parseInt(b.qSetACode.replace(/\D/g, ''), 10);
          const numC = parseInt(a.qSetBCode.replace(/\D/g, ''), 10);
          const numD = parseInt(b.qSetBCode.replace(/\D/g, ''), 10);
          return numA - numB || numC - numD;
        }),
    [similarityResult.data, similarityResult.duplicationRate],
  );

  if (!failedResults.length) {
    return null;
  }

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4), flexDirection: 'column', width: '100%' })}>
      <Box
        sx={(theme) => ({
          borderRadius: theme.shape.rounded(2),
          backgroundColor: theme.palette.grey[800],
          color: theme.palette.common.white,
          p: theme.spacing(2.5, 3),
        })}
      >
        <Text variant='h5'>รายละเอียดข้อสอบที่ซ้ำกัน</Text>
      </Box>
      <Flex sx={(theme) => ({ gap: theme.spacing(4), flexDirection: 'column' })}>
        {failedResults.map((result) => (
          <FailedResult
            key={result.id}
            courseId={courseId}
            resultId={similarityResult.id}
            comparisonId={result.id}
            qsetACode={result.qSetACode}
            qsetBCode={result.qSetBCode}
            duplicatedQuestionCount={result.duplicationCount}
          />
        ))}
      </Flex>
    </Flex>
  );
}
